import styled from 'styled-components';

const PassCoopeuchContenedor = styled.div`
  padding-top: 10px;
  .factor {
    text-align: center;
  }

.factor p {
  font-size: 13px;
  font-weight: 400;
  color: #333333;
  line-height: 18px;
  }
  .Button--complementary:hover:enabled {
    border: inherit;
    color: white;
  }
  .formulario-login-coopeuch.autorizacion button.Button.Button--secondary {
    border: none;
    background: none;
  }

  .formulario-login-coopeuch.autorizacion button.Button.Button--primary {
    float: right;
    width: 50%;
  }

  .passCoopeuch-autorizar {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .passCoopeuch-autorizar .box {
    margin-top: 10px;
  }

  .box.btn-autorizar {
    margin: 0 auto;
  }
  tiempo-pass-coopeuch .error{
    color: red;
  }
  .box.btn-autorizar button {
    padding: 9px 19px;
    margin-top: 14px;
    background-color: #007DB7;
    border-radius: 22px;
    font-weight: 400;
    font-size: 16px;
  }

  .box.btn-autorizar {
    margin: 0 38px;
}

.btn-autorizar .Button--secondary{
  background-color: #BF0238 !important;
  color: white !important;
  font-size: 12px;
}

  span.tiempo-pass-coopeuch {
    color: #646569;
    font-size: 12px;
    display: block;
    margin-top: 14px;
}
span.tiempo-pass-coopeuch strong {
  font-size: 12px;
}

.box.btn-autorizar img {
  width: 100px;
}
.false-reloj{
  margin-right: 5px !important;
}

span.tiempo-pass-coopeuch.error {
  color: #E4002B !important;
}

span.tiempo-pass-coopeuch.error p.usuario_cancelo{
  color: #E4002B !important;
  font-size:11px !important;
}

p.strong {
  color: #BF0238 !important;
  font-size: 13px !important;
  margin-bottom: 5px;
}

.contenedor-mensaje-error{
  padding: 13px !important;
}

span.tiempo-pass-coopeuch.error p{
  color: #E4002B ;
  font-size: 11px ;
}

span.tiempo-pass-coopeuch img {
  display: inline-block;
  vertical-align: baseline;
  margin-right: 10px;
}

.ClockHelper__label img {
  margin-right: 2px !important;
  height: 12px;
}

button:disabled,
button[disabled]{
  border: 1px solid;
  background-color: #D4D4D4 !important;
  color: #FFFFFF;
}

  @media (max-width: 426px){
    .AccordionItem--content {
      padding-right: 18px;
    }
    span.tiempo-pass-coopeuch {
      font-size: 11px !important;
  }
  .box img {
    width: 80%;
  }
  span.tiempo-pass-coopeuch strong {
      font-size: 11px !important;
  }
  .factor p{
    font-size: 12px;
}
.box.btn-autorizar {
  margin: 0 28px;
}
.accordion__button {
  font-size: 14px;
}
button.Button.Button--complementary {
  font-size: 13px !important;
}
.accordion__heading {
  font-size: 14px;
}
.contenedor-mensaje-error p {
  font-size: 10px !important;
}
.contenedor-mensaje-error p.strong {
  font-size: 11px !important;
}
.contenedor-mensaje-error img {
  width: 16px !important;
}
p.usuario_cancelo {
  font-size: 10px !important;
}

  }

  @media (max-width: 376px){
    .AccordionItem--content {
      padding-right: 18px;
    }
    span.tiempo-pass-coopeuch {
      font-size: 10px !important;
  }

  button.Button.Button--secondary {
    font-size: 11px !important;
}
p.ClockHelper__complementary-text span {
  font-size: 10px !important;
}
  span.tiempo-pass-coopeuch strong {
      font-size: 10px !important;
  }
  span.tiempo-pass-coopeuch img{
    width: 13px;
  }
  .factor p{
    font-size: 11px;
}
.box.btn-autorizar {
  margin: 0 28px;
}
.accordion__button {
  font-size: 14px;
}
button.Button.Button--complementary {
  font-size: 12px !important;
}
.accordion__heading {
  font-size: 14px;
}
.contenedor-mensaje-error p {
  font-size: 10px !important;
}
.contenedor-mensaje-error p.strong {
  font-size: 11px !important;
}
.contenedor-mensaje-error img {
  width: 16px !important;
}
p.usuario_cancelo {
  font-size: 10px !important;
}
span.ClockHelper__seconds {
  font-size: 10px !important;
}
span.ClockHelper__minutes {
  font-size: 10px !important;
}
  }

  @media (max-width: 320px){
    .box img {
      width: 100%;
  }
    .AccordionItem--content {
      padding-right: 18px;
    }
    span.tiempo-pass-coopeuch {
      font-size: 10px !important;
  }
  
  span.tiempo-pass-coopeuch strong {
      font-size: 10px !important;
  }
  span.tiempo-pass-coopeuch img{
    width: 19%;
  }
  img.false-reloj {
      width: 4%;
  }
  .factor p{
    font-size: 10px;
}
.box.btn-autorizar {
  margin: 0px 17px;
}
.accordion__button {
  font-size: 14px;
}
button.Button.Button--complementary {
  font-size: 10px !important
}
.accordion__heading {
  font-size: 14px;
}
span.ClockHelper__seconds {
  font-size: 10px !important;
}
span.ClockHelper__minutes {
  font-size: 10px !important;
}
img.false-reloj {
  width: 4% !important;
}
button.Button.Button--secondary {
  font-size: 11px !important;
}
.ClockHelper * {
  font-size: 10px !important;
}
.contenedor-mensaje-error p {
  font-size: 10px !important;
}
.contenedor-mensaje-error p.strong {
  font-size: 11px !important;
}
.contenedor-mensaje-error img {
  width: 16px !important;
}
p.usuario_cancelo {
  font-size: 10px !important;
}
  }
`;

export default PassCoopeuchContenedor;